/** =========================================================
 * Module: item-delete-dialog.directive.js
 * Delete item dialog
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemDeleteDialog', itemDeleteDialog);

  itemDeleteDialog.$inject = ['$rootScope', '$api', 'ngDialog', 'MainPreloader'];

  function itemDeleteDialog($rootScope, $api, ngDialog, MainPreloader) {
    var directive = {
      restrict: 'A',
      link: link,
      scope: {
        config: '=',
        item: '=',
        template: '@?'
      }
    };

    return directive;

    function link($scope, element) {
      element.on('click', function () {
        if ($scope.config && $scope.config.model && $scope.config.delete && typeof $scope.item !== 'undefined') {
          MainPreloader.show();

          var before = $rootScope.helpers.emptyPromise;
          var beforeSubmit = $rootScope.helpers.emptyPromise;
          var success = $rootScope.helpers.emptyPromise;

          if (typeof $scope.config.delete !== 'undefined') {
            if (typeof $scope.config.delete.before === 'function') {
              before = $scope.config.delete.before;
            }

            if (typeof $scope.config.delete.beforeSubmit === 'function') {
              beforeSubmit = $scope.config.delete.beforeSubmit;
            }

            if (typeof $scope.config.delete.success === 'function') {
              success = $scope.config.delete.success;
            }
          }

          before($scope.item, $scope).then(function () {
            MainPreloader.hide();

            $scope.message = 'Do you really want to delete?';
            $scope.title = $scope.item.title || $scope.item.name;

            ngDialog.openConfirm({
              template: $scope.template ? $scope.template : 'app/views/dialogs/confirm.html',
              scope: $scope,
              closeByDocument: false,
              closeByEscape: false
            }).then(function () {
              if ($scope.config.itemLoader) {
                $scope.item.loading = true;
              }

              beforeSubmit($scope.item).then(function (preparedItem) {
                $api.delete({
                  model: $scope.config.model,
                  data: preparedItem
                }).then(function (response) {
                  success(response, preparedItem, $scope).then(function () {
                    // if (typeof $scope.config.getData === 'function' && $scope.config.getDataParams) {
                    //     $scope.config.getData();
                    // }
                  });
                }, function (error) {
                  Raven.captureException(error);
                });
              });
            });
          }, MainPreloader.hide);
        }
      });
    }
  }
})();
